import { Serializable } from "@/core/api/decorators/serializable_decorator"

@Serializable
export class CurrencyConversionModel {
  amount: number = 0

  constructor(
    data: {
      amount: number
    } | null = null,
  ) {
    if (data) {
      this.amount = data.amount
    }
  }
}
